import { createRequestTypes } from '../utils';

export const CATEGORY_TR_LIST = createRequestTypes('categoryTR/CATEGORY_TR_LIST');
export const SAVE_CATEGORY_TRs = createRequestTypes('categoryTR/SAVE_CATEGORY_TRs');

